import { AlarmPriorityHeaders } from "./AlarmPriorityHeaders";
export default AlarmPriorityHeaders;
